var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-main',{staticClass:"main-container"},[_c('Main')],1),_c('el-backtop',{attrs:{"target":".main-container"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }